import Head from 'next/head'
import { FC } from 'react'
import env from '../../../env'
import { useTranslation } from '../../../hooks/useTranslation'
const BreadcrumbTags: FC = () => {
  const { translate } = useTranslation()
  const breadcrumObject = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'freeC Asia',
        item: env.PUBLIC_APP_DOMAIN
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: translate('job_by_location:seo_h1')
      }
    ]
  }
  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: `${JSON.stringify(breadcrumObject)}` }} />
    </Head>
  )
}

export default BreadcrumbTags
